import { useMemo } from 'react';
import { useLocation } from 'react-router';

import { decodeQuery } from '../utils';

const useSearchParams = <T = unknown>(): T => {
  const { search } = useLocation();
  const searchParams = useMemo(
    () =>
      decodeQuery(search) === ''
        ? Object.fromEntries(Array.from(new URLSearchParams(search)))
        : decodeQuery(search),
    [search]
  ) as T;

  return searchParams;
};

export default useSearchParams;
